import React from 'react';
import { motion } from 'framer-motion';
interface SectionWrapperProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function SectionWrapper({
  children,
  className = '',
  id
}: SectionWrapperProps) {
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${className}`} data-id="element-176">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-177">
        {children}
      </motion.div>
    </section>;
}